import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, Modal } from '@unimed-fesp/components';
import { FaClock } from 'react-icons/fa';
import { ModalContent, ModalContentWrapper } from '../../molecules/Modal';
import theme from '../../../styles/theme';
import { Container, ContentText, TextSucesso } from './styles';
import { Creators as AuthActions } from '../../../store/ducks/auth';

function ModalSessionExpired({ isOpen, onClick }) {
  const dispatch = useDispatch();

  const handleSignOut = () => {
    dispatch(AuthActions.signOutLegadoRequest());
  };

  return (
    <Modal
      isOpen={isOpen}
      onClick={onClick}
      height={345}
      width={460}
      footer={<ModalFooter onClick={onClick} handleSignOut={handleSignOut} />}
    >
      <ModalContentWrapper>
        <ModalContent>
          <Container>
            <FaClock color={theme.greenDefault} size="100" />
            <TextSucesso text="Sessão Expirada" />
            <ContentText>
              Seu acesso expirou. Por favor, faça login novamente para
              continuar.
            </ContentText>
          </Container>
        </ModalContent>
      </ModalContentWrapper>
    </Modal>
  );
}

const ModalFooter = ({ handleSignOut }) => {
  return (
    <>
      <Button
        tipo="primary"
        onClick={handleSignOut}
        color={theme.bgWhite}
        marginLeft={10}
        width={100}
        alignCenter
        justifyCenter
      >
        OK
      </Button>
    </>
  );
};

export default ModalSessionExpired;
